import {
  CHEMKIT_DASHBOARD_COMPONENT_NAME,
  CHEMKIT_DASHBOARD_EVENT_AGGREGATE,
  CHEMKIT_DASHBOARD_EVENT_CLOSED,
  CHEMKIT_DASHBOARD_EVENT_OPEN_CLICKED,
  CHEMKIT_DASHBOARD_EVENT_OPEN_FAILED,
  CHEMKIT_DASHBOARD_EVENT_OPEN_READY,
  CHEMKIT_DASHBOARD_EVENT_OPENED,
  CHEMKIT_DASHBOARD_CONFIG_WINDOW_KEY,
} from '@chemkit/contracts/integration/dashboard';

export const DASHBOARD_COMPONENT_NAME = CHEMKIT_DASHBOARD_COMPONENT_NAME;

export const DASHBOARD_CONFIG_WINDOW_KEY = CHEMKIT_DASHBOARD_CONFIG_WINDOW_KEY;

export const DASHBOARD_EVENT_AGGREGATE = CHEMKIT_DASHBOARD_EVENT_AGGREGATE;

export const DASHBOARD_EVENT_OPEN_CLICKED = CHEMKIT_DASHBOARD_EVENT_OPEN_CLICKED;

export const DASHBOARD_EVENT_OPEN_READY = CHEMKIT_DASHBOARD_EVENT_OPEN_READY;

export const DASHBOARD_EVENT_OPENED = CHEMKIT_DASHBOARD_EVENT_OPENED;

export const DASHBOARD_EVENT_OPEN_FAILED = CHEMKIT_DASHBOARD_EVENT_OPEN_FAILED;

export const DASHBOARD_EVENT_CLOSED = CHEMKIT_DASHBOARD_EVENT_CLOSED;
